@if (!loadingDisplay) {
  <div class="files container" style="padding-right: 0px; padding-left: 0px">
    <div class="row justify-content-left me-3" style="margin-left: 0px !important">
      <div class="col-12" style="padding-left: 0px !important; padding-right: 0px !important">
        <i-button
          [text]="getSuperButtonAddFilDocumentText()"
          [childrenItems]="buttons"
          styleClass="green w-100 text-center justify-content-center mb-3">
        </i-button>
        @if (selectedFiles.length > 0) {
          <i-button
            styleClass="blue w-100 text-center justify-content-center mb-3"
            [text]="'courrierFiche.actionOnSelection' | translate"
            [childrenItems]="buttonsSelectedFiles">
          </i-button>
        }
        @if (!loadingDisplay && uploadedFiles.length > 0 && canDisplayDownloadAll) {
          <i-button
            [text]="'courrierFiche.downloadAllFiles' | translate"
            icon="bi bi-file-earmark-arrow-down-fill"
            styleClass="blue w-100 text-center my-3 justify-content-center"
            (click)="downloadAll(uploadedFiles)"
            iconPosition="left"></i-button>
        }
        @if (rightMailInfo?.files?.add) {
          <p-fileUpload
            #pFileUpload
            name="myfileUpload[]"
            multiple="multiple"
            accept=".xls,.xlsx,.odt,.docx,.doc,.pptx,.ppt,.pdf,.rar,.zip,.json,.mp4,.msg,.rtf,.txt,.jpeg,.jpg,.png,.gif,.tiff,.eml"
            fileLimit="100"
            [showUploadButton]="false"
            [showCancelButton]="false"
            [chooseLabel]="'courrierFiche.addFiles' | translate"
            styleClass="fileUploadCustomv2 w-100"
            class="d-block w-100"
            [customUpload]="true"
            (onSelect)="onSelectFiles($event)"
            showChooseButton="true"
            showUploadButton="false"
            showCancelButton="false">
          </p-fileUpload>
        }
      </div>
    </div>
    @if (loadingDisplay) {
      <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    }
    @if (loadingDisplay) {
      <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    }
    @if (loadingDisplay) {
      <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    }
    @if (loadingDisplay) {
      <p-skeleton styleClass="mb-2" width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    }
    @if (loadingDisplay) {
      <p-skeleton width="100%" height="3rem" borderRadius="16px"></p-skeleton>
    }
    @if (!loadingDisplay && uploadedFiles.length > 0 && rightMailInfo?.files?.view) {
      <p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 380px)' }" styleClass="custombar1">
        @if (uploadedFiles.length > 0 && rightMailInfo?.files?.view) {
          <div class="mt-3 manageOverflow">
            <div>
              <div style="position: relative; padding-left: 10px" class="center-div d-flex align-items-center justify-content-left mb-2">
                <p-checkbox class="me-2" name="groupname" inputId="checkAll" [binary]="true" (onChange)="checkAllFiles($event)"> </p-checkbox>
                <label for="checkAll" class="mt-2 ms-2 cursor--pointer">Tout sélectionner/ Tout désélectionner</label>
              </div>
            </div>
            @for (a of uploadedFiles; track a; let i = $index) {
              <div [ngClass]="{ 'super-compos-activeFile': +fileCurrent?.id === +a?.id }" style="cursor: pointer">
                <div
                  style="position: relative"
                  class="center-div d-flex align-items-center justify-content-left mb-2"
                  [ngClass]="{ 'me-3': +fileCurrent?.id !== +a?.id }">
                  <span class="object__checkbox me-1">
                    <label class="containerc containerc--block">
                      <input type="checkbox" [(ngModel)]="selected_by_id[i]" (change)="checkboxFiles($event, i)" />
                      <span
                        class="checkmark checkmark--block"
                        [ngClass]="{ 'checkmark-gray': !selected_by_id[i], 'checkmark-gray-checked': selected_by_id[i] }"></span>
                    </label>
                  </span>
                  <div class="center-div w-100" (click)="onOpenFile(a, $event); currentIndexFile = i">
                    <div class="d-flex align-items-center" style="gap: 8px">
                      @if (
                        a?.extension.toLowerCase() === 'jpg' ||
                        a?.extension.toLowerCase() === 'png' ||
                        a?.extension.toLowerCase() === 'jpeg' ||
                        a?.extension.toLowerCase() === 'svg' ||
                        a?.extension.toLowerCase() === 'tif'
                      ) {
                        <i class="bi--big_icon bi bi-file-earmark-image-fill"></i>
                      }
                      @if (a?.extension.toLowerCase() === 'doc' || a?.extension.toLowerCase() === 'docx') {
                        <i class="bi--big_icon bi bi-filetype-doc"></i>
                      }
                      @if (a?.extension.toLowerCase() === 'xls' || a?.extension.toLowerCase() === 'xlsx') {
                        <i class="bi--big_icon bi bi-filetype-xls"></i>
                      }
                      @if (a?.extension.toLowerCase() === 'pdf') {
                        <i class="bi--big_icon bi bi-filetype-pdf"></i>
                      }
                      @if (a?.extension.toLowerCase() === 'xps') {
                        <i class="bi--big_icon bi bi-filetype-xml"></i>
                      }
                      @if (a?.extension.toLowerCase() === 'txt') {
                        <i class="bi--big_icon bi bi-filetype-txt"></i>
                      }
                      @if (a?.extension.toLowerCase() === 'rtf') {
                        <i class="iconRTFFileSCSS--biggerIcon"></i>
                      }
                      @if (a?.extension.toLowerCase() === 'htm') {
                        <i class="bi--big_icon bi bi-filetype-html"></i>
                      }
                      @if (a?.extension.toLowerCase() === 'odt') {
                        <i class="iconODTFileSCSS"></i>
                      }
                      @if (a?.extension.toLowerCase() === 'pptx' || a?.extension.toLowerCase() === 'ppt') {
                        <i class="bi--big_icon bi bi-filetype-ppt"></i>
                      }
                      <div style="width: 100%">
                        <div class="mb-0 file__infosDescription">
                          <div class="file__infosDescription-div">
                            {{ a?.description ? a?.description : a?.name }}
                            {{ a?.description && a?.hasExtensionInDescription === false ? '.' + a?.extension : '' }}
                          </div>
                        </div>
                        <p class="mb-0 file__infosV2">
                          <span class="version"> V{{ a?.version }}</span>
                          @if (a?.isPrincipal) {
                            <span><i class="ms-2 bi bi-star-fill"></i> {{ 'courrierFiche.mainDocument' | translate }}</span>
                          }
                        </p>
                        @if (a?.dateUpload) {
                          <p class="mb-0 file__infosV2">
                            {{ 'courrierFiche.updatedOn' | translate }} : {{ a?.dateUpload | momentFormat: 'DD/MM/YYYY à HH:mm' }}
                          </p>
                        }
                        @if (a?.editeurSourceType) {
                          <p class="mb-0 file__infosV2">{{ 'source' | translate }} : {{ a?.editeurSourceType }}</p>
                        }
                        @if (a.procedureValidationValidationOk !== null) {
                          <p class="file__subtitle">
                            <u>{{ 'courrierFiche.validationStatus' | translate }} :</u>
                            {{ statusValidation | label_by_id: a.procedureValidationValidationOk ?? -1 }}
                            <!-- On ne va afficher le rôle et le service que si la validation est
                            0 => Validation en cours
                            5 => Validation en attente
                            20 => Validation lancée -->
                            @if (
                              a.procedureValidationValidationRoleId &&
                              a.procedureValidationValidationServiceId &&
                              (a.procedureValidationValidationOk === 0 ||
                                a.procedureValidationValidationOk === 5 ||
                                a.procedureValidationValidationOk === 20)
                            ) {
                              <span>
                                ( {{ roles | label_by_id: a.procedureValidationValidationRoleId }} >>
                                {{ services | label_by_id: a.procedureValidationValidationServiceId }} )
                              </span>
                            }
                          </p>
                        }
                        @if (clientType === 'JVS' && a?.statusPastellLabel) {
                          <p class="file__subtitle">
                            <u>{{ 'courrierFiche.pastelStatus' | translate }} :</u> {{ a?.statusPastellLabel }}
                          </p>
                        }
                        @if (clientType === 'JVS' && a?.pastellDateLimite) {
                          <p class="file__subtitle">
                            <u>{{ 'courrierFiche.pastelDeadline' | translate }} :</u>
                            {{ a?.pastellDateLimite | momentFormat: 'DD/MM/YYYY' }}
                          </p>
                        }
                        @if (clientType !== 'JVS' && a.procedureValidationSignatureOk !== null) {
                          <p class="file__subtitle">
                            <u>{{ 'courrierFiche.signatureStatus' | translate }} : </u>
                            {{ statusSignature | label_by_id: a.procedureValidationSignatureOk ?? -1 }}
                            @if (a.procedureValidationSignatureRoleId && a.procedureValidationSignatureServiceId) {
                              <span>
                                ( {{ roles | label_by_id: a.procedureValidationSignatureRoleId }} >>
                                {{ services | label_by_id: a.procedureValidationSignatureServiceId }} )
                              </span>
                            }
                          </p>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="file__chevron">
                    <i class="bi bi-chevron-down" (click)="op.toggle($event)"></i>
                  </div>
                  <p-overlayPanel #op appendTo="body">
                    <ng-template pTemplate>
                      @if (rightMailInfo?.files?.open && a.downloadFileRight === true) {
                        <span class="dropdown-element" (click)="download(a, op)">{{ 'courrierFiche.download' | translate }}</span>
                      }
                      @if (rightMailInfo?.files?.open && a?.editeurSourceType === 'Externe' && a.extension === 'rtf') {
                        <span class="dropdown-element" (click)="showPdf(a, op)">{{ 'courrierFiche.previewPDF' | translate }}</span>
                      }
                      @if (rightMailInfo?.files?.open && a.extension === 'rtf') {
                        <span class="dropdown-element" (click)="openPublipostage(a, op)">{{ 'courrierFiche.mailMerge' | translate }}</span>
                      }
                      @if (rightMailInfo?.files?.addVersions && a.extension === 'rtf' && a.hasRightToNewVersion) {
                        <span class="dropdown-element" (click)="addNewVersion(a, op)">{{ 'courrierFiche.newVersion' | translate }}</span>
                      }
                      @if (a?.procedureValidationValidationOk !== null) {
                        <span class="dropdown-element" (click)="showHistoriqueValidation(a, op)"
                          >{{ 'courrierFiche.validationHistory' | translate }} {{ clientType !== 'JVS' ? '/signature' : '' }}</span
                        >
                      }
                      @if (a?.pastellStatus !== null && clientType === 'JVS') {
                        <span class="dropdown-element" (click)="showHistoriquePastell(a, op)">{{ 'courrierFiche.approvalHistory' | translate }}</span>
                      }
                      @if (a?.canPerformValidateAction) {
                        <span class="dropdown-element" (click)="validationDocument(a, true, op)">{{
                          'courrierFiche.validateWithComment' | translate
                        }}</span>
                      }
                      @if (a?.canPerformValidateAction) {
                        <span class="dropdown-element" (click)="validationDocument(a, false, op)">{{
                          'courrierFiche.validateWithoutComment' | translate
                        }}</span>
                      }
                      @if (a?.canPerformValidateAction) {
                        <span class="dropdown-element" (click)="refuseValidation(a, op)">{{ 'courrierFiche.rejectValidation' | translate }}</span>
                      }
                      @if (
                        a?.procedureValidationSignatureOk === 0 &&
                        a?.procedureValidationSignatureId !== null &&
                        a?.canPerformSignatureAction &&
                        clientType !== 'JVS'
                      ) {
                        <span class="dropdown-element" (click)="refuseSignature(a, op)">{{ 'courrierFiche.rejectSignature' | translate }}</span>
                      }
                      @if (a.extension === 'pdf' && a.pastellCircuitId === null && clientType === 'JVS') {
                        <span class="dropdown-element" (click)="openModalAssignCircuitPastell(a, op)">{{
                          'courrierFiche.assignACircuit' | translate
                        }}</span>
                      }
                      @if (rightMailInfo?.files?.edit) {
                        <span class="dropdown-element" (click)="showDescDialog = true; setFilename(a, op)">{{
                          'courrierFiche.editDescription' | translate
                        }}</span>
                      }
                      @if (rightMailInfo?.files?.edit && !a?.isPrincipal) {
                        <span class="dropdown-element" (click)="setAsMainDocument(a, op)">{{ 'courrierFiche.setAsMainDocument' | translate }}</span>
                      }
                      @if (rightMailInfo?.files?.edit) {
                        <span class="dropdown-element" (click)="changeSourceFile(a, op)">{{ 'courrierFiche.convertFileSource' | translate }} </span>
                      }
                      @if (rightMailInfo?.files?.delete) {
                        <span class="dropdown-element" (click)="deleteFile(a, op)">{{ 'courrierFiche.delete' | translate }}</span>
                      }
                    </ng-template>
                  </p-overlayPanel>
                </div>
              </div>
            }
          </div>
        }
      </p-scrollPanel>
    }
    @if (!loadingDisplay && uploadedFiles.length === 0) {
      <div class="w-100 d-block text-center mt-4">
        <img class="img-fluid m-auto d-block" src="./assets/img/decoration/nofile.svg" width="500" alt="" />
        @if ((rightMailInfo && rightMailInfo?.files?.open === false) || rightMailInfoError === true) {
          <span>{{ 'courrierFiche.notAuthorized' | translate }}</span>
        }
      </div>
    }
  </div>
}

<p-dialog
  [(visible)]="importModal"
  [style]="{ width: '50vw' }"
  styleClass="modal-bigger modal-scss"
  [modal]="true"
  [closable]="true"
  appendTo="body"
  (onHide)="cancel()">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'courrierFiche.importFiles' | translate }}</h5>
    </div>
  </p-header>
  <div class="row mb-3">
    <div class="col-md-8">
      <label class="super-compos-label-input"> {{ 'courrierFiche.idMail' | translate }} </label>
      <input
        [(ngModel)]="courrierID"
        id="autofocus"
        type="number"
        class="super-compos-input-text form-control w-100"
        [placeholder]="'courrierFiche.searchIDMail' | translate"
        name="ID du courrier à rechercher" />
    </div>
    <div class="col-md-4 mt-4">
      <i-button [text]="'courrierFiche.searchFiles' | translate" styleClass="blue" (click)="searchFilesByCourrierID(courrierID)"></i-button>
    </div>
  </div>
  @if (filesFromCourriers.length > 0) {
    <div class="row">
      <div class="col-md-12">
        <i-table
          [paginator]="true"
          class="super-table"
          [columns]="columnsFiles"
          [items]="filesFromCourriers"
          id="filesFromCourriers"
          [forselectionDefaultOption]="false"
          [reorder]="true"
          [multiselect]="true"
          [showForSelection]="false"
          (columnSelected)="onRowSelection($event)"
          [height]="'calc( 70vh - 200px )'">
        </i-table>
      </div>
    </div>
  }
  @if (filesFromCourriers.length === 0 && launchSearchImport && showError === false) {
    <div class="row">
      <div class="col-md-12 mt-3">
        <div class="alert alert-warning">{{ 'courrierFiche.noFiles' | translate }}</div>
      </div>
    </div>
  }
  @if (launchSearchImport && showError === true) {
    <div class="row mb-3">
      <div class="col-md-12 mt-3">
        <div class="alert alert-warning">{{ 'courrierFiche.noResult' | translate }}</div>
      </div>
    </div>
  }

  <i-button styleClass="bottomButton green mb-2" (click)="validate()" [text]="'courrierFiche.selectForImport' | translate"></i-button>
  <i-button styleClass="bottomButton red" (click)="cancel()" [text]="'cancel' | translate"></i-button>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  [(visible)]="showDescDialog"
  [style]="{ width: '50vw' }"
  [header]="'courrierFiche.modifyFiles' | translate"
  [modal]="true"
  [closable]="true"
  appendTo="body">
  <div class="row mb-3">
    <div class="col-md-10">
      <label class="super-compos-label-input"> {{ 'courrierFiche.fileName' | translate }} </label>
      <input
        [(ngModel)]="filename"
        type="text"
        class="super-compos-input-text form-control w-100"
        [placeholder]="'courrierFiche.fileName' | translate" />
    </div>
  </div>
  <i-button text="Modifier" styleClass="bottomButton green" (click)="updateFile()"></i-button>
</p-dialog>

<p-dialog
  [(visible)]="showUploadModalFile"
  [style]="{ width: '50vw' }"
  [header]="'courrierFiche.uploadFileNewVersion' | translate"
  [modal]="true"
  [closable]="true"
  appendTo="body">
  <div class="row mt-4">
    <div class="col-md-6 mb-3">
      <div class="square h-100" (click)="showPdf(fileCurrent)">
        <i class="bi--big_icon bi bi-filetype-pdf icon me-0"></i>
        <p class="answerTitle">{{ 'courrierFiche.previewPDF' | translate }}</p>
      </div>
    </div>
    <div class="col-md-6 mb-3">
      <div class="square h-100" (click)="download(fileCurrent)">
        <i class="bi bi-download icon me-0"></i>
        <p class="answerTitle">{{ 'courrierFiche.downloadFile' | translate }}</p>
      </div>
    </div>
    <div class="col-md-6 mb-3">
      <div class="square">
        <p-fileUpload
          #pFileUpload
          name="myfileUpload[]"
          multiple="false"
          accept=".rtf"
          fileLimit="10000"
          [showUploadButton]="false"
          [showCancelButton]="false"
          [chooseLabel]="'courrierFiche.addFiles' | translate"
          styleClass="fileUploadCustom w-100"
          class="d-block w-100"
          [customUpload]="true"
          (onSelect)="addDocument($event, pFileUpload)"
          showChooseButton="false"
          showUploadButton="false"
          showCancelButton="false">
        </p-fileUpload>
        <p class="answerTitle">{{ 'courrierFiche.uploadFile' | translate }}</p>
      </div>
    </div>
    <div class="col-md-6 mb-3">
      <div class="square h-100" (click)="displayParagraphes = true; getParagraphes()">
        <i class="bi bi-text-paragraph icon me-0"></i>
        <p class="answerTitle">{{ 'courrierFiche.textLibrary' | translate }}</p>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="showPDFModal"
  [style]="{ width: '50vw' }"
  [header]="'action.previewPDF' | translate"
  [modal]="true"
  [closable]="true"
  appendTo="body">
  <div class="row">
    <div class="col-md-12">
      @if (pdfConverted) {
        <span>
          <ngx-extended-pdf-viewer
            [src]="pdfConverted"
            height="100vh"
            [zoom]="'auto'"
            [showFindButton]="true"
            [showPagingButtons]="true"
            [showZoomButtons]="true"
            [showPresentationModeButton]="true"
            [showOpenFileButton]="false"
            [showPrintButton]="false"
            [showDownloadButton]="false"
            [showSecondaryToolbarButton]="true"
            [showRotateButton]="true"
            [showHandToolButton]="true"
            [showScrollingButton]="true"
            [showSpreadButton]="false"
            [showPropertiesButton]="true"
            [customToolbar]="additionalButtons"
            [(page)]="currentPage">
          </ngx-extended-pdf-viewer>
          <ng-template #additionalButtons>
            <div id="toolbarViewer">
              <div id="toolbarViewerLeft">
                <pdf-toggle-sidebar></pdf-toggle-sidebar>
                <div class="toolbarButtonSpacer"></div>
                <pdf-find-button [showFindButton]="true" [textLayer]="true"></pdf-find-button>
                <pdf-paging-area></pdf-paging-area>
              </div>
              <div id="toolbarViewerRight">
                <pdf-presentation-mode></pdf-presentation-mode>
                <pdf-select-tool></pdf-select-tool>
                <pdf-rotate-page></pdf-rotate-page>
                <pdf-hand-tool></pdf-hand-tool>
                <pdf-toggle-secondary-toolbar></pdf-toggle-secondary-toolbar>
              </div>
              <pdf-zoom-toolbar></pdf-zoom-toolbar>
            </div>
          </ng-template>
        </span>
      }
    </div>
  </div>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  [(visible)]="showPublipostage"
  [style]="{ width: '50vw' }"
  header="Publipostage"
  [modal]="true"
  [closable]="true"
  (onHide)="annuler()"
  appendTo="body">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'courrierFiche.mailMerge' | translate }}</h5>
    </div>
  </p-header>
  <form [formGroup]="formPubli">
    <div class="row mb-3">
      <div class="col-md-6 d-flex justify-content-left">
        <label class="custom-label-input me-2">{{ 'courrierFiche.generatePDF' | translate }}</label>
        <p-inputSwitch formControlName="pdf"></p-inputSwitch>
      </div>
      <div class="col-md-6 d-flex justify-content-left">
        <label class="custom-label-input me-2">{{ 'courrierFiche.generateMergeFile' | translate }}</label>
        <p-inputSwitch formControlName="fusion"></p-inputSwitch>
      </div>
    </div>
    <p-tabView>
      <p-tabPanel header="Destinataire">
        <label class="custom-label-input"> {{ 'courrierFiche.recipient' | translate }} </label>
        <div class="row">
          <div class="col-md-12">
            @if (public_contacts.length > 0) {
              <p-multiSelect
                [options]="public_contacts | sort: 'label' : 'ASC'"
                emptyLabel="Sélectionnez un ou plusieurs destinataire"
                formControlName="contactIds"
                [filter]="true"
                styleClass="w-100 dropdown-inforius mb-2"
                appendTo="body"
                [emptyFilterMessage]="'courrierFiche.noResultsFound' | translate">
              </p-multiSelect>
            }
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Source externe">
        <div class="mt-2 mb-2">
          <i-button styleClass="blue" (click)="downloadTemplatePublipostage()" [text]="'courrierFiche.downloadTemplate' | translate"></i-button>
        </div>
        <p-fileUpload
          #fileUpload
          [files]="excelFiles"
          [auto]="true"
          styleClass="file-upload-simple"
          customUpload="true"
          (uploadHandler)="onUpload($event)"
          multiple="false"
          accept=".xlsx"
          maxFileSize="1000000"
          [showCancelButton]="false"
          [chooseLabel]="'courrierFiche.selectExcelFile' | translate"
          [uploadLabel]="'courrierFiche.uploadExcelFile' | translate">
        </p-fileUpload>
        @if (selectedPublipostageLibre.length > 0) {
          <div class="alert alert-primary mt-3 mb-3">{{ 'courrierFiche.selectedRecipientsOnly' | translate }}</div>
        }
        @if (dataExcel.length > 0) {
          <i-table
            (columnSelected)="receive_selected($event)"
            [initialSelection]="dataExcel"
            id="publipostage"
            [columns]="colExcel"
            class="super-table"
            [items]="dataExcel"
            [paginator]="false"
            [multiselect]="true"></i-table>
        }
      </p-tabPanel>
    </p-tabView>
  </form>
  <i-button styleClass="bottomButton red mb-3" (click)="annuler()" [text]="'cancel' | translate"></i-button>
  <i-button styleClass="bottomButton green" (click)="submitPubli()" [text]="'confirm' | translate"></i-button>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  [(visible)]="showValidateDocument"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '60vw' }"
  [closable]="true">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'courrierFiche.validateWithComment' | translate }}</h5>
    </div>
  </p-header>
  <div class="row mb-3" [formGroup]="formValidation">
    <div class="col-md-12 mb-2">
      <label class="super-compos-label-input">{{ 'courrierFiche.comment' | translate }}</label>
      <textarea
        rows="5"
        cols="30"
        [placeholder]="'courrierFiche.insertComment' | translate"
        formControlName="justification"
        class="super-compos-input-text form-control w-100"
        pInputTextarea></textarea>
    </div>
  </div>
  <i-button
    styleClass="bottomButton red mb-3"
    (click)="formValidation.reset(); showValidateDocument = false"
    [text]="'cancel' | translate"></i-button>
  <i-button text="Confirmer" styleClass="bottomButton green" (click)="validationComment()"></i-button>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  [(visible)]="showRefuseSignatureDocument"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '60vw' }"
  [closable]="true">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'courrierFiche.rejectWithComment' | translate }}</h5>
    </div>
  </p-header>
  <div class="row mb-3" [formGroup]="formSignature">
    <div class="col-md-12 mb-2">
      <label class="super-compos-label-input">{{ 'courrierFiche.comment' | translate }}</label>
      <textarea
        rows="5"
        cols="30"
        [placeholder]="'courrierFiche.insertComment' | translate"
        formControlName="justification"
        class="super-compos-input-text form-control w-100"
        pInputTextarea></textarea>
    </div>
  </div>
  <i-button styleClass="bottomButton red mb-3" (click)="showRefuseSignatureDocument = false" text="Annuler"></i-button>
  <i-button text="Confirmer" styleClass="bottomButton green" (click)="refuseWithComment()"></i-button>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  [(visible)]="refuseModal"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '60vw' }"
  [closable]="true">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'courrierFiche.rejectValidation' | translate }}</h5>
    </div>
  </p-header>
  <div class="row mb-3" [formGroup]="formModal" #questionModal>
    <div class="col-md-12">
      <i-title text="Choix de l'étape" level="2"></i-title>
      <div>
        @if (refuseItems && refuseItems.previousStep && refuseItems.previousStep.length > 0) {
          <i-table
            [paginator]="true"
            (onClickRow)="select($event)"
            class="super-table"
            [columns]="columnsRefuse"
            [items]="refuseItems.previousStep"
            id="table-refuse-validation"
            [multiselect]="false"
            [search]="true">
          </i-table>
        }
        @if (formModal.get('previousStepName')?.value) {
          <div class="alert alert-primary mb-2">{{ 'courrierFiche.selectedStep' | translate }} : {{ formModal.get('previousStepName')?.value }}</div>
        }
        @if (
          refuseItems &&
          refuseItems?.previousStep &&
          refuseItems?.previousStep.length === 1 &&
          refuseItems?.contacts &&
          refuseItems?.contacts.length > 0
        ) {
          <div class="col-md-12 mb-2">
            <label class="super-compos-label-input"
              >{{ 'courrierFiche.managerChoice' | translate }}
              @if (formModal.get('contactId')?.errors?.required === true) {
                <span> *</span>
              }
            </label>
            <p-dropdown
              styleClass="w-100"
              [options]="refuseItems?.contacts"
              [placeholder]="'courrierFiche.selectManager' | translate"
              [showClear]="true"
              formControlName="contactId"
              appendTo="body"
              [virtualScroll]="true"
              [filter]="true"
              virtualScrollItemSize="30">
            </p-dropdown>
          </div>
        }
        <div class="col-md-12 mb-2">
          <label class="super-compos-label-input">{{ 'courrierFiche.comment' | translate }}</label>
          <textarea
            rows="5"
            cols="30"
            [placeholder]="'courrierFiche.insertComment' | translate"
            formControlName="justification"
            class="super-compos-input-text form-control w-100"
            pInputTextarea></textarea>
        </div>
      </div>
    </div>
  </div>
  <i-button styleClass="bottomButton red mb-3" (click)="refuseModal = false" [text]="'cancel' | translate"></i-button>
  <i-button styleClass="bottomButton green" (click)="submitRefuse()" [text]="'confirm' | translate"></i-button>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  [(visible)]="showModalHistorique"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '60vw' }"
  [closable]="true">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'courrierFiche.validationSignatureHistory' | translate }}</h5>
    </div>
  </p-header>
  <div class="row mb-3">
    <div class="col-md-12 mb-2">
      @if (historiqueFile.length > 0) {
        <mgl-timeline [toggle]="false" [alternate]="true">
          @for (entry of historiqueFile; track entry; let i = $index) {
            <mgl-timeline-entry>
              <mgl-timeline-entry-header>
                <div class="objet">
                  <div class="object__body">
                    <div class="object__header">
                      <div class="object__header--left">
                        <b class="object__user">{{ entry?.description }}</b>
                        <span> ({{ entry?.contactName }})</span>
                      </div>
                      <span class="object__date"> {{ entry?.date | momentFormat: 'DD/MM/YYYY à HH:mm' }} </span>
                    </div>
                    <div class="object__content">
                      <div class="object__title">{{ 'courrierFiche.message' | translate }} : {{ entry?.message ? entry?.message : '/' }}</div>
                      @if (entry?.fromService) {
                        <span> {{ 'action.fromService' | translate: { fromService: entry?.fromService } }} </span>
                      }
                      @if (entry?.toService) {
                        <span> {{ 'action.toService' | translate: { toService: entry?.toService } }} </span>
                      }
                    </div>
                  </div>
                </div>
              </mgl-timeline-entry-header>
              <mgl-timeline-entry-content
                [expandAnimationTiming]="contentAnimation ? '200ms ease' : '0ms'"
                [collapseAnimationTiming]="contentAnimation ? '100ms ease' : '0ms'">
              </mgl-timeline-entry-content>
              <mgl-timeline-entry-dot [class]="entry?.typeEntrantSortant === 'S' ? 'customAlternate' : ''" [size]="size"> </mgl-timeline-entry-dot>
              <mgl-timeline-entry-side [class]="entry?.typeEntrantSortant === 'S' ? 'customAlternate' : ''">
                {{ entry.date | momentFormat: 'DD/MM/YYYY' }}
              </mgl-timeline-entry-side>
            </mgl-timeline-entry>
          }
        </mgl-timeline>
      }
    </div>
  </div>
  <i-button styleClass="bottomButton red mb-3" (click)="showModalHistorique = false" [text]="'close' | translate"></i-button>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  [(visible)]="showModalHistoriquePastell"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '60vw' }"
  [closable]="true">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'courrierFiche.approvalHistory' | translate }}</h5>
    </div>
  </p-header>
  <div class="row mb-3">
    <div class="col-md-12 mb-2">
      @if (historiqueFilePastell.length > 0) {
        <mgl-timeline [toggle]="false" [alternate]="true">
          @for (entry of historiqueFilePastell; track entry; let i = $index) {
            <mgl-timeline-entry>
              <mgl-timeline-entry-header>
                <div class="objet">
                  <div class="object__body">
                    <div class="object__header">
                      <div class="object__header--left">
                        <b class="object__user">{{ entry?.fullName }}</b>
                      </div>
                      <span class="object__date"> {{ entry?.date | momentFormat: 'DD/MM/YYYY à HH:mm' }} </span>
                    </div>
                    <div class="object__content">
                      <div class="object__title">{{ 'courrierFiche.annotation' | translate }} : {{ entry?.annotation }}</div>
                      @if (entry?.status) {
                        <span> {{ 'courrierFiche.status' | translate }} : {{ entry?.status }} </span>
                      }
                    </div>
                  </div>
                </div>
              </mgl-timeline-entry-header>
              <mgl-timeline-entry-content
                [expandAnimationTiming]="contentAnimation ? '200ms ease' : '0ms'"
                [collapseAnimationTiming]="contentAnimation ? '100ms ease' : '0ms'">
              </mgl-timeline-entry-content>
              <mgl-timeline-entry-dot [class]="'customAlternate'" [size]="size"> </mgl-timeline-entry-dot>
              <mgl-timeline-entry-side [class]="'customAlternate'"> {{ entry.date | momentFormat: 'DD/MM/YYYY' }} </mgl-timeline-entry-side>
            </mgl-timeline-entry>
          }
        </mgl-timeline>
      }
    </div>
  </div>
  <i-button styleClass="bottomButton red mb-3" (click)="showModalHistoriquePastell = false" [text]="'global.quit' | translate"></i-button>
</p-dialog>

<p-confirmDialog
  key="remplacantCourrierCreateAddFiles"
  #cd
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  [header]="'confirm' | translate"
  icon="bi bi-exclamation-triangle"
  baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
<p-confirmDialog
  key="deleteFileConfirm"
  #cd2
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  [header]="'confirm' | translate"
  icon="bi bi-exclamation-triangle"
  baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="cd2.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate" (click)="cd2.accept()"></button>
  </p-footer>
</p-confirmDialog>

<p-sidebar position="right" [(visible)]="displayParagraphes" styleClass="ui-sidebar-sm" [modal]="false">
  <div class="ms-1 me-1">
    <i-title [text]="'courrierFiche.textLibrary' | translate"></i-title>
    <input type="text" class="form-control w-100 mt-3 mb-3" [(ngModel)]="searchValueBibli" />
  </div>
  <i-accordion [hideShowAllBtn]="true">
    @for (item of paragraphes | keyvalue; track item; let i = $index) {
      <i-accordion-tab header="{{ item.key }}" class="box" [showEditBtn]="false">
        <div class="mergeFields">
          @for (text of item.value | sort: 'description' : 'ASC' | searchByKey: 'description' : searchValueBibli; track text) {
            <div class="cell" (click)="copy(text)">
              <div [pTooltip]="text.texte"><i class="bi bi-copy me-1"></i>{{ text.description }}</div>
            </div>
          }
        </div>
      </i-accordion-tab>
    }
  </i-accordion>
</p-sidebar>
